

import Button from '@/components/global/Button'
export default {
  name: 'FollowBack',
  components: {
    Button
  }
}
